<template>
<div id="filtr">
  <Loader :loading="loading" />

  <!-- FEATURES -->
  <div class="table">
    <!-- <draggable v-model="featuresData" group="people" @end="onDragEnd" class="available-filters" :disabled="!isDraggable"> -->
    <div class="available-filters">
      <div
            v-for="(feature, featureId) in features"
            :key="featureId"
            v-if="feature.isPresent || feature.toAdd"
            class="filtr-wrapper"
      >
        <!-- to add -->
        <!-- <div
              class="filtr-toadd"
              v-show="feature.toAdd"
        >
          <p class="filtr-name">
            <button
                  class="hide-group"
                  @click="alterFeature(featureId)"
                  v-if="feature.name != 'bundle_id'"
            >
              <i class="fas fa-times"></i>
            </button>
            <strong>
              {{ feature.name }}
            </strong>
          </p>
        </div> -->

        <!-- to remove -->
        <div
              class="filtr-toremove"
              v-show="feature.isPresent && feature.toRemove"
        >
          <p class="filtr-name">
            <button
                  class="hide-group"
                  @click="alterFeature(featureId)"
            >
              <i class="fas fa-caret-right"></i>
            </button>
            <strong>
              {{ feature.name }}
            </strong>
          </p>
        </div>

        <!-- present -->
        <div
              class="filtr-present"
              v-show="feature.isPresent && !feature.toRemove"
        >

          <div class="filtr-head">
            <div class="filtr-name">
              <div class="filtr-name-close">
                <button
                      class="hide-group"
                      @click="alterFeature(featureId)"
                      v-if="feature.name != 'bundle_id'"
                >
                  <i class="fas fa-caret-down"></i>
                </button>
                <strong>
                  {{ feature.name }}
                </strong>
              </div>

              <div class="filter-btns">
                <div v-show="isAnyRowSelected(featureId)" class="btn-group apply-filters-btn">
                  <div
                        class="btn"
                        @click="markRecords(featureId, feature)"
                  >
                    Mark
                  </div>
                  <div 
                    class="btn-color-picker">
                    <v-swatches v-model="colorpicker.selectedColor" :swatches="colorpicker.predefinedColors" popover-x="left">
                      <i slot='trigger' :style='{color: colorpicker.selectedColor}' class='fas fa-square-full'></i>
                    </v-swatches>
                  </div>
                </div>
                <div
                      class="apply-filters-btn"
                      v-show="isAnyRowSelected(featureId)"
                      @click="applyFilters(activeFilters)"
                >
                  Apply Filters
                </div>

                <span
                      class="clear-all"
                      @click="clearFilter(feature.name)"
                      v-if="activeFilters.hasOwnProperty(feature.name)"
                >Clear Filters</span>
                <i
                      class="fas fa-filter"
                      v-if="activeFilters.hasOwnProperty(feature.name)"
                      @mouseover="toggleFold(feature.name,true)"
                      @mouseleave="toggleFold(feature.name,false)"
                >
                  <div
                        class="dropdown"
                        :class="{show: activeFilters[feature.name].unfold}"
                  >
                    <div class="filtered-label">Filtered by</div>
                    <ul class="subfilters">
                      <li
                            class="subfilter"
                            v-for="(sf,sfId) in activeFilters[feature.name].fValues"
                            :key="sfId"
                            :class="{removing: sf.remove}"
                            @click="toggleSubFilter(feature.name, sfId )"
                      >{{sf.value}}
                        <i
                              class="fas fa-times"
                              v-if="!sf.remove"
                        ></i>
                        <i
                              class="fas fa-plus"
                              v-else
                        ></i>
                      </li>
                    </ul>

                    <div
                          class="apply-filters-btn"
                          :class="{clickable: activeFilters[feature.name].fValues.filter(sf => sf.remove==true).length >= 1}"
                          @click="applyFiltersAndFold(activeFilters,feature.name)"
                    >
                      Apply Filters
                    </div>
                  </div>

                </i>
              </div>
            </div>

            <div class="input-tip">
              <input
                    type="text"
                    class="search"
                    :placeholder="icon"
                    @input="searchFilters($event,fRows[featureId].rows)"
                    v-on:keyup.enter="selectMultiple(featureId)"
              >

              <div class="tip">
                Enter to select all
              </div>
            </div>

          </div>

          <div class="filtr-body">
            <div class="filtr-values">
              <div class="filtr-values-column">
                <span class="header-cell"></span>

                <table v-if="fRows.length >0">
                  <!-- HEADERS -->
                  <tr class="headers">
                    <th class="allign-center">
                      <span
                            @click="sortByName(fRows[featureId].rows)"
                            class="name"
                      >
                        name
                      </span>
                    </th>
                    <!-- H EVENTS -->
                    <th
                          v-for="(event,id) in events"
                          v-show="event.isPresent && !event.toRemove"
                          :key="event.name"
                    >
                      <span
                            class="header-cell"
                            :style="StylesForEventOverview(event.name)"
                            @click="sort(fRows[featureId].rows,'events',id)"
                      >
                        {{ event.name.substring(0, 3)}}{{(event.name.substring(0, 3) == "exp" || event.name.substring(0, 3) == "rev") ? "$" : ""}}
                      </span>
                    </th>

                    <!-- H FORMULAS -->
                    <th
                          v-for="(f,id) in formulas"
                          :key="100+id"
                    >
                      <span
                            class="header-cell"
                            @click="sortStringsAsNumber(fRows[featureId].rows,id)"
                      >
                        {{f.name}}
                      </span>
                    </th>

                  </tr>

                  <!--SUMS -->
                  <span
                        class="create-sum cell filtr-value-cell"
                        v-show="fRows[featureId].rows.filter(row => row.isSelected==true).length > 1"
                        @click="createFeaturesSum(fRows[featureId],featureId)"
                  >
                    &#10010;
                  </span>

                  <tr
                        class="cell filtr-value-cell features-sums"
                        v-for="(fsum,sumId) in sums[featureId]"
                        :key="200+sumId"
                  >
                    <td class="cell-name">
                      <span
                            class="delete-sum"
                            @click="deleteFeaturesSum(featureId,sumId)"
                      >&#10006; {{fsum.value}}</span>
                    </td>

                    <!-- S FEATURES -->
                    <td
                          v-for="(event,eventId) in events"
                          v-show="event.isPresent"
                          :key="300+eventId"
                          :style="StylesForEventOverview(event.name)"
                    >
                      {{fsum.events[eventId]}}
                    </td>

                    <!-- S FORMULAS -->
                    <td
                          v-for="(f,id) in formulas"
                          :key="400+id"
                    >
                      {{fsum.custom[id]}}
                    </td>
                  </tr>

                  <!-- VALUES -->
                  <tr
                        class="cell filtr-value-cell"
                        v-for="(featureRow,id) in fRows[featureId].rows"
                        :key="500+id"
                        @click="selectFilter(featureRow)"
                        :style="highlightRecord(featureRow)"
                        :class="{ selected: featureRow.isSelected, firstCell: id==0}"
                        v-show="featureRow.visible"
                  >
                    <!-- V FEATURES -->
                    <td class="cell-name">
                      {{featureRow.value}}
                    </td>
                    <td
                          v-for="(event,eventId) in events"
                          v-show="event.isPresent && !event.toRemove"
                          :key="600+eventId"
                          :style="StylesForEventOverview(event.name)"
                    >
                      {{featureRow.events[eventId]}}
                    </td>

                    <!-- V FORMULAS -->
                    <td
                          v-for="(f,id) in formulas"
                          :key="700+id"
                    >
                      {{ featureRow.custom[id]}}
                    </td>
                  </tr>
                </table>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- </draggable> -->
    <div
          class="add-attributes"
          @mouseover="dropdownOpen=true"
          @mouseleave="dropdownOpen=false"
    >
      <!-- :class="{pending: features.filter(f => f.toAdd==true).length >= 1}" -->
      <i class="fas fa-plus"></i>
      <div
            class="attr-dropdown"
            id="attr-dropdown"
      >
        <div class="substrate">

        </div>
        <span class="label-head">Add attributes</span>
        <ul class="attr-options">
          <li
                v-for="(f,id) in features"
                :key="id"
                class="attr__select"
                v-if="f.name!='bundle_id'"
          >
            <!-- @click="alterFeature(id)" -->
            <input
                  type="checkbox"
                  name=""
                  v-model="f.checkbox"
                  @click="alterFeature(id)"
            >

            {{f.name}}
            <i class="fas fa-question">
              <div class="tooltip">
                <div class="tooltiptext">{{f.tip}}</div>
              </div>
            </i>
          </li>
        </ul>
        <button
              class="attr-update"
              :class="{disabled: !someSelected}"
              @click="applyFiltersAndCloseDropdown(activeFilters)"
        >UPDATE</button>
      </div>
      <div class="label">
        ADD ATTRIBUTES
      </div>
    </div>
  </div>
</div>
</template>

<script>
// import ChartRes from '@/resources/Chart.js';
import Loader from '@/components/Loader.vue'
import HelpersRes from '@/helpers/Helpers.js';
import store from "@/store/store.js"
import {
  Parser
} from "hot-formula-parser";
import VSwatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.css'
// import draggable from 'vuedraggable'

export default {
  components: {
    Loader,
    VSwatches
    // draggable,
  },
  props: {
    loading: {
      type: Boolean,
      default: true,
      required: true
    },
    onFiltersSelect: {
      type: Function,
      default: () => {},
      required: true
    },
    onAttributeSelect: {
      type: Function,
      default: () => {},
      required: true
    },
    // onfeaturesReorder: {
    //   type: Function,
    //   default: () => [],
    //   required: true
    // },
    onApplyFilters: {
      type: Function,
      default: () => {},
      required: true
    },
    onMarkAction: {
      type: Function,
      default: () => {},
      required: true
    }
  },
  watch: {
    dropdownOpen: {
      handler: function(isOpen) {
        var addAttrs = document.getElementById("attr-dropdown");
        if (addAttrs === null) {
          return
        }

        if (isOpen) {
          var viewportOffset = addAttrs.getBoundingClientRect();
          // these are relative to the viewport, i.e. the window
          // var top = viewportOffset.top;
          // var left = viewportOffset.left;
          // addAttrs.style.top = top + "px";
          // addAttrs.style.left = left + "px";

          var right = viewportOffset.right;
          var left = viewportOffset.left;
          addAttrs.style.right = right + "px";
          addAttrs.style.left = left + "px";

          addAttrs.style.position = "fixed";
          addAttrs.style.visibility = "visible"
          addAttrs.style.opacity = "1"
        } else {
          addAttrs.style.right = "0";
          addAttrs.style.left = "auto";
          addAttrs.style.position = "absolute";
          addAttrs.style.visibility = "hidden"
          addAttrs.style.opacity = "0"
        }
      },
      immediate: true,
    }
  },
  computed: {
    activeFilters() {
      var activeFilters = {}
      for (var key of Object.keys(store.state.filter)) {
        activeFilters[key] = {
          remove: false,
          fName: key,
          fValues: [],
          unfold: false,
        }

        for (var i = 0; i < store.state.filter[key].length; i++) {
          activeFilters[key].fValues.push({
            remove: false,
            value: store.state.filter[key][i],
          })
        }
      }

      return activeFilters
    },

    // sums: {
    //   // getter
    //   get: function() {
    //     var sums = []
    //     for (var i = 0; i < store.state.features.length; i++) {
    //       sums.push([])
    //     }
    //     return sums
    //   },
    //   // setter
    //   set: function(newValue) {
    //     this.sums = newValue
    //   }
    // },

    sums() {
      var sums = []
      for (var i = 0; i < store.state.features.length; i++) {
        sums.push([])
      }
      return sums
    },
    formulas() {
      return store.state.formulas
    },
    fRows() {
      var parser = new Parser();
      var sFormulas = store.state.formulas
      var sEvents = store.state.events
      var sFRows = store.state.featuresRows
      var fRows = []
      for (var i = 0; i < sFRows.length; i++) {
        var rows = sFRows[i]
        fRows.push({
          rows: rows,
        })

        for (var j = 0; j < fRows[i].rows.length; j++) {
          fRows[i].rows[j].custom = []
          fRows[i].rows[j].visible = true

          for (var k = 0; k < sFormulas.length; k++) {
            for (var z = 0; z < sEvents.filter(e => e.isPresent == true).length; z++) {
              parser.setVariable('_' + sEvents[z].name + '_', fRows[i].rows[j].events[z]);
            }
            var res = parser.parse(sFormulas[k].equation);
            if (res.result == null) {
              fRows[i].rows[j].custom[k] = "-"
            } else {
              fRows[i].rows[j].custom[k] = (Math.round(res.result * 100) / 100).toFixed(2);
            }
          }
        }
      }

      return fRows
    },

    features() {
      // var parser = new Parser();
      // var sFormulas = store.state.formulas
      // var sEvents = store.state.events
      var sFeatures = store.state.features
      var features = []

      for (var i = 0; i < sFeatures.length; i++) {
        var checkbox = false
        if (sFeatures[i].toRemove) {
          checkbox = false
        } else if (sFeatures[i].toAdd) {
          checkbox = true
        } else {
          checkbox = sFeatures[i].isPresent
        }

        features.push({
          name: sFeatures[i].name,
          isPresent: sFeatures[i].isPresent,
          toRemove: sFeatures[i].toRemove,
          toAdd: sFeatures[i].toAdd,
          rows: [],
          tip: sFeatures[i].tip,
          checkbox: checkbox,
        })
      }
      return features
    },

    events() {
      return store.state.events
    },
    eventsToDisplay: function() {
      var eventsToDisplay = []
      for (var i = 0; i < this.events.length; i++) {
        if (this.events[i].isPresent) {
          eventsToDisplay.push(this.events[i].name)
        }
      }
      return eventsToDisplay
    },
    dateRangeIsSmall() {
      return HelpersRes.SubDates(store.state.dates.startDate, store.state.dates.endDate) <= 7
    }
  },
  data() {
    return {
      someSelected: false,
      dropdownOpen: false,
      sortOrder: false,
      defaultVisibleGroups: ["bundle_id", "product_id", "media_source", "campaign", "ios_version", "geo"],
      requestedEvents: this.initialEvents,
      featuresGroups: {},
      icon: '\uf002',
      EventTipID: -1,
      colorpicker: {
        selectedColor: "#FF0000",
        predefinedColors: [
          "#1FBC9C",
          "#1CA085",
          "#2ECC70",
          "#27AF60",
          "#3398DB",
          "#2980B9",
          "#A463BF",
          "#8E43AD",
          "#F2C511",
          "#F39C19",
          "#FF0000",
          "#C0382B",
        ]
      }
    }
  },
  methods: {
    refresh() {
      // inputs
      var elements = document.getElementsByTagName("input");
      for (var ii = 0; ii < elements.length; ii++) {
        if (elements[ii].type == "text") {
          elements[ii].value = "";
        }
      }

      //sums
      for (var i = 0; i < this.sums.length; i++) {
        this.sums[i] = []
      }
    },
    applyFiltersAndCloseDropdown(activeFilters) {
      this.dropdownOpen = false
      this.applyFilters(activeFilters)
    },
    applyFiltersAndFold(activeFilters, fName) {
      this.toggleFold(fName, false)
      this.applyFilters(activeFilters)
    },
    toggleSubFilter(filterName, valueId) {
      var toRemove = !this.activeFilters[filterName].fValues[valueId].remove
      this.activeFilters[filterName].fValues[valueId].remove = toRemove
      if (toRemove == false) {
        this.activeFilters[filterName].remove = toRemove
      } else {
        var removingAll = true
        for (var i = 0; i < this.activeFilters[filterName].fValues.length; i++) {
          if (!this.activeFilters[filterName].fValues[i].remove) removingAll = false
        }
        this.activeFilters[filterName].remove = removingAll
      }

      this.$forceUpdate()
      this.activeFiltersSelected = this.activeFiltersToRemove()
    },

    toggleFold(featureName, isUnfold) {
      this.activeFilters[featureName].unfold = isUnfold
      this.$forceUpdate()
    },
    clearFilter(filterName) {
      this.activeFilters[filterName].remove = true
      this.applyFilters(this.activeFilters)
    },
    alterFeature(id) {
      store.commit('alterFeature', id)
      this.someSelected = this.features.some((f) => {
        return f.toAdd
      })
      this.onAttributeSelect(this.someSelected)
    },
    isEmpty(obj) {
      return Object.keys(obj).length === 0;
    },
    // mouseup() {
    //   this.isDraggable = true;
    // },
    // mousedown() {
    //   this.isDraggable = false;
    // },
    // onDragEnd(e) {
    //   if (e.oldIndex !== e.newIndex) {
    //     var featuresToDsiplayReordered = this.features.slice()
    //     featuresToDsiplayReordered.splice(e.newIndex, 0, featuresToDsiplayReordered.splice(e.oldIndex, 1)[0])
    //     this.onfeaturesReorder(featuresToDsiplayReordered)
    //   }
    // },

    searchFilters(e, data) {
      data.forEach((fvalueData) => {
        if (!fvalueData.value.toLowerCase().match(e.target.value.toLowerCase())) {
          fvalueData.visible = false
        } else {
          fvalueData.visible = true
        }
      })
      this.$forceUpdate();
    },
    sortStringsAsNumber(group, formulaId) {
      let fId = formulaId
      this.sortOrder = !this.sortOrder
      let sortingOrder = this.sortOrder
      let sortFunc = function compare(a, b) {
        var aa = Number(a.custom[fId])
        var bb = Number(b.custom[fId])

        if (!sortingOrder) {
          if (isNaN(aa) && !isNaN(bb)) return 1;
          if (isNaN(bb) && !isNaN(aa)) return -1;
          if (aa < bb) return -1;
          if (bb < aa) return 1;
        } else {
          if (isNaN(aa) && !isNaN(bb)) return 1;
          if (isNaN(bb) && !isNaN(aa)) return -1;
          if (aa < bb) return 1;
          if (bb < aa) return -1;
        }
        return 0;
      }

      group.sort(sortFunc)
      this.$forceUpdate();
    },
    sort(group, entetiesToSort, eventId) {
      let sortingEventId = eventId
      let sortingEnteties = entetiesToSort
      this.sortOrder = !this.sortOrder
      let sortingOrder = this.sortOrder
      let sortFunc = function compare(a, b) {
        if (!sortingOrder) {
          if (a[sortingEnteties][sortingEventId] < b[sortingEnteties][sortingEventId]) return -1;
          if (b[sortingEnteties][sortingEventId] < a[sortingEnteties][sortingEventId]) return 1;
        } else {
          if (a[sortingEnteties][sortingEventId] < b[sortingEnteties][sortingEventId]) return 1;
          if (b[sortingEnteties][sortingEventId] < a[sortingEnteties][sortingEventId]) return -1;
        }
        return 0;
      }

      group.sort(sortFunc)
      this.$forceUpdate();
    },
    sortByName(data) {
      this.sortOrder = !this.sortOrder
      let sortingOrder = this.sortOrder
      let sortFunc = function compare(a, b) {
        if (!sortingOrder) {
          if (a.value > b.value) return -1;
          if (b.value > a.value) return 1;
        } else {
          if (a.value > b.value) return 1;
          if (b.value > a.value) return -1;
        }

        return 0;
      }

      data.sort(sortFunc)
      this.$forceUpdate();
    },
    deleteFeaturesSum(featureId, sumId) {
      this.sums[featureId].splice(sumId, 1)
      this.$forceUpdate()
    },
    createFeaturesSum(feature, featureId) {
      var fLen = feature.rows.length
      var eLen = feature.rows[0].events.length
      var cLen = this.formulas.length
      var sum = {
        value: 'sum' + String(this.sums[featureId].length + 1),
        events: Array(eLen).fill(0),
        custom: Array(cLen).fill(0),
      }

      //Events SUMS
      for (var i = 0; i < fLen; i++) {
        if (feature.rows[i].isSelected == true) {
          for (var j = 0; j < eLen; j++) {
            sum.events[j] = (sum.events[j] + feature.rows[i].events[j])
          }
          feature.rows[i].isSelected = false
        }
      }

      for (var i = 0; i < sum.events.length; i++) {
        if (sum.events[i] % 1 != 0) {
          sum.events[i] = sum.events[i].toFixed(2)
        }
      }

      //Formulas sums
      var parser = new Parser();
      for (var z = 0; z < this.formulas.length; z++) {
        for (var k = 0; k < sum.events.length; k++) {
          parser.setVariable('_' + this.events[k].name + '_', sum.events[k]);
        }
        var res = parser.parse(this.formulas[z].equation);
        if (res.result == null) {
          sum.custom[z] = ("-")
        } else {
          sum.custom[z] = ((Math.round(res.result * 100) / 100).toFixed(2));
        }
      }
      this.sums[featureId].push(sum)

      this.$forceUpdate()

      this.someSelected = this.features.some((f) => {
        return f.toAdd
      })
      this.onAttributeSelect(this.someSelected)
      this.onFiltersSelect(this.filtersSelectState())
    },
    StylesForEventOverview(objName) {
      return HelpersRes.StylesForEventOverview(objName)
    },

    filtersSelectState() {
      var someSelected = false
      for (var i = 0; i < this.fRows.length; i++) {
        this.fRows[i].rows.some((row) => {
          if (row.isSelected) {
            someSelected = true
            return true
          }
        })
        if (someSelected) return someSelected
      }
      return someSelected
    },

    selectMultiple(featureId) {
      this.fRows[featureId].rows.forEach((row) => {
        if (row.visible) {
          row.isSelected = !row.isSelected
        }
      })
      this.$forceUpdate()
      this.onFiltersSelect(this.filtersSelectState())
    },
    selectFilter(filterData) {
      filterData.isSelected = !filterData.isSelected
      // this.$forceUpdate()
      this.onFiltersSelect(this.filtersSelectState())
    },
    applyFilters(activeFilters) {
      var selectedFilters = {}

      Object.keys(activeFilters).forEach((key) => {
        var af = activeFilters[key]
        if (!af.remove) {
          selectedFilters[af.fName] = []
          af.fValues.forEach(v => {
            if (!v.remove) selectedFilters[af.fName].push(v.value)
          })
        }
      })

      for (var i = 0; i < this.fRows.length; i++) {
        var selectedTemp = []
        this.fRows[i].rows.forEach((fvalueData) => {
          if (fvalueData.isSelected) {
            selectedTemp.push(fvalueData.value)
          }
        })
        if (selectedTemp.length != 0) {
          selectedFilters[this.features[i].name] = selectedTemp
        }
      }

      this.onApplyFilters(selectedFilters)
      this.someSelected = false
    },
    markRecords(featureId, feature) {
      let color = this.colorpicker.selectedColor.replace("#", "")

      let selected = this.fRows[featureId].rows.filter(row => row.isSelected)

      this.onMarkAction(feature.name, color,  selected)
        .then(() => {
          selected.forEach(row => {
            row.color = row.color === "" ? color : "" 
            row.isSelected = false
            this.onFiltersSelect(false)
          })
        })
        .catch(err => {
          console.error(err)
          // TODO: show error to the user
        })
    },

    downloadCSV() {
      var header = ['name']
      this.events.forEach(e => {
        if (e.isPresent && !e.toRemove) {
          header.push(e.name)
        }
      })

      this.formulas.forEach(f => {
        header.push(f.name)
      })

      var toDownload = [
        [header]
      ]

      for (var i = 0; i < this.fRows.length; i++) {
        this.fRows[i].rows.forEach((fRow) => {
          if (fRow.isSelected) {
            var row = [fRow.value].concat(fRow.events).concat(fRow.custom)
            toDownload.push([row])
          }
        })
      }

      this.rowsToCsv("selected", toDownload)
    },

    rowsToCsv(fName, rows) {
      var csv = '';
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        for (var j = 0; j < row.length; j++) {
          var val = row[j] === null ? '' : row[j].toString();
          val = val.replace(/\t/gi, " ");
          if (j > 0)
            csv += '\t';
          csv += val;
        }
        csv += '\n';
      }

      // for UTF-16
      var cCode, bArr = [];
      bArr.push(255, 254);
      for (var k = 0; k < csv.length; ++k) {
        cCode = csv.charCodeAt(k);
        bArr.push(cCode & 0xff);
        bArr.push(cCode / 256 >>> 0);
      }

      var blob = new Blob([new Uint8Array(bArr)], {
        type: 'text/csv;charset=UTF-16LE;'
      });
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fName);
      } else {
        var link = document.createElement("a");
        if (link.download !== undefined) {
          var url = window.URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fName);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }
      }
    },
    highlightRecord(feature) {
      return feature.color.length === 6 ? {'color': `#${feature.color}`} : {}
    },
    isAnyRowSelected(featureId) {
      return this.fRows.length >0 && this.fRows[featureId].rows.filter(row => row.isSelected==true).length >= 1
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css">

</style>

<style lang="scss">
@import '../assets/variables.scss';
#filtr {
    font-family: Arial, FontAwesome;
    // box-shadow: 1px 2px 4px 0 rgba(0, 0, 0, 0.33);
    padding-bottom: 10px;
    position: relative;
    padding: 0 10px;
    ul {
        list-style-type: none;
    }

    .table {
        display: flex;
        // justify-content: space-between;
        flex-direction: row;
        height: 70vh;
        .available-filters {
            display: flex;
            flex-direction: row;
            height: 70vh;
            overflow-x: scroll;
        }
        .add-attributes {
            position: relative;
            display: inline-block;
            max-width: 100%;
            padding: 4px;
            border-radius: 5px;
            color: #fff;
            line-height: 1;
            background: white;
            color: darken($greenSelect,10%);
            font-weight: bold;
            font-size: 14px;
            white-space: nowrap;
            overflow: hidden;
            max-width: 100%;
            // text-overflow: ellipsis;
            overflow: visible;
            user-select: none;
            border: 1px solid #EDEDED;
            box-sizing: border-box;
            border-radius: 3px;
            width: 33px;
            .fa-plus {
                font-size: 20px;
                color: $newBlue;
            }
            .label {
                color: #25B0FF;
                font-size: 14px;
                line-height: 16px;
                writing-mode: tb-rl;
                margin-left: auto;
                margin-right: auto;
                margin-top: 5px;
            }
            &:hover {
                cursor: pointer;
                // .attr-dropdown {
                //     visibility: visible;
                //     opacity: 1;
                // }
            }

            .attr-dropdown {
                left: auto;
                right: 0;
                width: 265px;
                height: 300px;
                overflow-y: initial;
                position: absolute;
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                background-color: white;
                margin-top: 0;
                border-radius: 0.35em;
                list-style-type: none;
                z-index: 9999;
                padding: 6px 7px 2px;
                // text-align: right;
                font-weight: normal;
                box-shadow: 0 5px 10px rgba(0, 0, 0, 0.16);
                border-radius: 5px;

                visibility: hidden;
                opacity: 0;
                // transition: all 200ms linear;
                text-align: left;

                .substrate {
                    height: 25px;
                    width: 95%;
                    position: absolute;
                    margin-top: -20px;
                }

                .attr-options {
                    padding-left: 0;
                    display: flex;
                    flex-wrap: wrap;
                    max-height: 75%;
                    overflow: scroll;
                    margin: 7px 0;
                }
                .attr-update {
                    width: 95%;
                    background-color: $newOrange;
                    color: white;
                    border-radius: 4px;
                    height: 30px;
                    margin-left: auto;
                    margin-right: auto;
                    font-weight: bold;
                    border: none;
                    &.disabled {
                        color: gray;
                        border-color: gray;
                        background-color: white;
                    }
                }
                .label-head {
                    color: black;
                    font-weight: bold;
                    width: calc(100% + 7px);
                    border-bottom: 1px solid #EDEDED;
                    padding-bottom: 4px;
                    margin-right: -7px;
                    margin-left: -7px;
                    padding-left: 7px;
                }
                &.show {
                    visibility: visible;
                    opacity: 1;
                }
                .attr__select {
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                    position: relative;
                    height: 20px;
                    min-width: 110px;
                    padding: 4px 12px 4px 10px;
                    border-radius: 5px;
                    // margin-right: 4px;
                    color: black;
                    line-height: 1;
                    margin-bottom: 2px;
                    white-space: nowrap;
                    max-width: 100%;
                    text-transform: capitalize;
                    font-size: 13.5px;
                    input {
                        width: 20px;
                        height: 20px;
                        &:hover {
                            cursor: pointer;
                        }
                    }

                    // &:hover {
                    // cursor: pointer;
                    // background: darken(white,3%);
                    // > .fa-question {
                    //     display: block;
                    // }
                    // }

                    // &.present {
                    //     color: #fff;
                    //     background: #41b883;
                    //     border-color: $green;
                    // }
                    // &.removing {
                    //     // background-color: $lightGray;
                    //     background-color: lighten($greenSelect,25%);
                    //     // color: black;
                    // }
                    // &.adding {
                    //     background-color: $darkBlue;
                    //     color: white;
                    // }

                    .fa-question {
                        display: none;
                        padding: 3px;
                        margin-top: auto;
                        margin-bottom: auto;
                        font-size: 10px;
                        position: relative;
                        .tooltip {
                            width: 120px;
                            min-height: 50px;
                            background-color: #FF7F50;
                            text-align: center;
                            padding: 5px 0;
                            border-radius: 6px;

                            /* Position the tooltip text */
                            position: absolute;
                            z-index: 10;
                            top: 140%;
                            margin-left: -100px;

                            /* Fade in tooltip */
                            visibility: hidden;
                            opacity: 0;
                            transition: opacity 0.3s;
                            .tooltiptext {
                                white-space: initial;
                                position: relative;
                                color: white;
                                font-size: 14px;
                                font-weight: bold;
                                padding: 5px;
                            }
                            &:after {
                                content: "";
                                position: absolute;
                                border-right: 7px solid transparent;
                                border-left: 7px solid transparent;
                                border-bottom: 9px solid #FF7F50;
                                // left: -6px;
                                right: 12px;
                                top: -6px;

                                // top: 9px;

                            }
                        }

                        &:hover .tooltip {
                            visibility: visible;
                            opacity: 1;
                        }
                    }
                }
            }
        }
    }

    .filtr-name {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 5px;
        margin-top: 5px;
        margin-bottom: 5px;
        text-align: left;
        text-transform: uppercase;
        font-style: normal;
        font-weight: bold;
        font-size: 13px;
        line-height: 21px;
        filtr-name-close {}
        .filter-btns {
            display: flex;
            align-items: center;
            color: $newOrange;
            font-size: 12px;
            font-weight: normal;
            .apply-filters-btn {
                width: 90px;
                height: 20px;
                font-weight: bold;
                margin-right: 6px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: $newOrange;
                border-radius: 3px;
                font-size: 12px;
                // line-height: 14px;
                color: white;
                text-align: center;
                text-transform: capitalize;
                &:hover {
                    cursor: pointer;
                }
            }
            .clear-all {
                text-decoration: underline;
                margin-right: 8px;
                text-transform: capitalize;
                &:hover {
                    cursor: pointer;
                }
            }
            .fa-filter {
                position: relative;
                font-size: 13px;
                &:hover {
                    cursor: pointer;
                }
                .dropdown {
                    position: absolute;
                    background-color: white;
                    margin-top: 0.45em;
                    border-radius: 0.35em;
                    list-style-type: none;
                    z-index: 9999;
                    padding: 0 8px 6px;
                    text-align: left;
                    left: -4px;
                    font-weight: normal;
                    box-shadow: 0 0 3px #ccc;
                    white-space: nowrap;
                    color: black;
                    background: #FFFFFF;
                    border: 1px solid #EDEDED;

                    visibility: hidden;
                    opacity: 0;
                    transition: all 200ms linear;

                    &.show {
                        visibility: visible;
                        opacity: 1;
                    }
                    .filtered-label {
                        border-bottom: 1px solid #EDEDED;
                        font-weight: bold;
                        text-transform: capitalize;
                        padding: 7px 4px;
                        margin-left: -8px;
                        margin-right: -8px;
                    }
                    ul {
                        padding-left: 0;
                    }
                    .subfilter {
                        margin-bottom: 4px;
                        display: flex;
                        justify-content: space-between;
                        &.removing {
                            color: $darkBlue;
                        }
                        .fa-plus,
                        .fa-times {
                            margin-left: 10px;
                        }
                        .fa-plus {
                            color: $newBlue;
                        }
                    }
                    .apply-filters-btn {
                        margin-left: auto;
                        margin-right: auto;
                        background-color: $newBackground;
                        color: #666666;
                        pointer-events: none;
                        &.clickable {
                            pointer-events: all;
                            background: $newOrange;
                            color: white;
                        }
                    }
                }
            }
        }
    }
    .filtr-wrapper {
        display: flex;
        flex-direction: column;

        .filtr-toremove {
            background-color: white;
        }
        .filtr-toremove {
            height: 100%;
            border: 1px solid #EDEDED;
            .filtr-name {
                writing-mode: tb-rl;
                margin-right: 5px;
                margin-left: 5px;
                padding: 0;
            }
            .hide-group {
                text-align: center;
                border: none;
                background-color: transparent;
                color: $newBlue;
            }
        }
        .filtr-present {
            display: flex;
            flex-direction: column;
            text-align: left;
            // border-right: 1px solid;
            // border-bottom: 1px solid;
            border: 1px solid #EDEDED;
            box-sizing: border-box;
            border-radius: 3px;
            height: 100%;
            .filtr-head {
                background-color: $newBackground;
                padding: 8px 10px;
                border-bottom: 1px solid #EDEDED;
                text-align: center;
                input {
                    width: 97%;
                    border: 1px solid #EDEDED;
                    box-sizing: border-box;
                    border-radius: 3px;
                }
            }
            .filtr-body {
                display: flex;
                background-color: white;
                height: 100%;
                padding: 7px 10px;
                overflow: scroll;
            }
            .hide-group {
                float: left;
                text-align: center;
                border: none;
                background-color: transparent;
            }
            .multiselect-width {
                max-width: 300px;
            }
            .cohort-label {
                display: flex;
            }
        }
    }

    select {
        z-index: 100;
    }

    .filtr-values {
        display: flex;
        font-size: 13px;
        white-space: nowrap;
        overflow-y: scroll;
        width: 100%;

        .create-sum {
            color: $green;
            cursor: pointer;
        }

        table {
            border-spacing: 0;
            table-layout: fixed;
            border-collapse: collapse;
            // th {
            //     text-align: center;
            //     position: sticky;
            //     top: 0;
            // }
            tr {
                padding-bottom: 3px;
                // border-bottom: 1px solid #e8e8e8;
                &:hover {
                    cursor: pointer;
                }
                &.features-sums {
                    border-color: $blue;
                    cursor: default;
                }
            }
            td {
                width: 1px;
                white-space: nowrap;
                padding: 3px 2px;
                text-align: center;
                &.cell-name {
                    text-align: left;
                }
                .delete-sum {
                    color: $red;
                    cursor: pointer;
                }
            }
        }
        .header-cell {
            // min-height: 8px;
            padding-right: 3px;
            padding-left: 3px;
            text-align: center;
        }
        .headers {
            border-bottom: 1px solid #EDEDED;
            th {
                text-align: center;
                background-color: white;
                position: sticky;
                top: 0;
                &:first-child {
                    text-align: left;
                }
            }
            .name {
                font-size: 12px;
                line-height: 14px;
                color: #666666;
            }
        }
        .filtr-values-column {
            display: flex;
            flex-direction: column;
            width: 100%;
        }
        .tip {
            text-transform: capitalize;
            text-align: center;
            border-radius: 4px;
            padding: 12px;
            position: fixed;
            margin-top: 20px;
            z-index: 999;
            color: black;
            background-color: white;
            box-shadow: 1px 2px 4px 0 rgba(0, 0, 0, 0.33);
        }
    }

    button:hover {
        cursor: pointer;
    }

    button:focus {
        outline: 0;
    }

    .hide-group img {
        width: 15px;
        height: 15px;
    }

    .selected {
        background-color: rgba(255, 120, 44, 0.15);
        // color: white !important;
    }

    .hidden-groups-container {
        display: flex;
        flex-direction: column;
    }

    .show-group {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: 3px;
    }

    .show-group img {
        margin-top: 2px;
    }

    input:focus,
    textarea:focus {
        outline: none;
    }

    input {
        font-family: FontAwesome;
        font-size: 14px;
        letter-spacing: 0.4px;
    }

    .input-tip {
        position: relative;
        input:focus + div {
            visibility: visible;
        }
        .search {
            position: relative;
            display: inline-block;
            min-height: 25px;
            line-height: 20px;
            border: none;
            border-radius: 5px;
            background: #fff;
            padding: 0 0 0 5px;
            width: 100%;
            -webkit-transition: border 0.1s ease;
            transition: border 0.1s ease;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            vertical-align: top;
            &::placeholder {
                /* Chrome, Firefox, Opera, Safari 10.1+ */
                color: $newBlue;
                opacity: 1;
                font-size: 13px;
                /* Firefox */
            }
        }

        .tip {
            position: absolute;
            top: 0;
            right: 0;
            height: 25px;
            line-height: 25px;
            margin-right: 3%;
            color: $newOrange;
            visibility: hidden;
            font-size: 13px;
            opacity: 0.7;
            &.shown {
                visibility: visible;
            }
        }
    }

    .required {
        border-color: #D96767;

    }

    .vdp-datepicker__calendar {
        width: 274px !important;
    }

    .filtr-values::-webkit-scrollbar {
        -webkit-appearance: none;
        width: 6px;
    }

    .filtr-values::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background-color: rgba(0, 0, 0, .5);
        -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, .5);
    }

    .btn-group {
      .btn {
        width: 70%;
        border-right: 1px solid white;
      }
      .btn-color-picker {
        width: 30%;
      }
    }
}
</style>
